import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { withTheme } from 'styled-components';
import { Alert, Card } from 'crux';
import Section from './Section';
import ScrollToTop from '../../ScrollToTop';
import MemberDetailsAlerts from './MemberDetailsAlerts';
import {
  getCombinedSectionQuestions,
  isMemberDetailsSubsection,
  isVerifyMemberInfoSection,
  isSecondaryAddresseeSection,
  isIoBlockingOwnerSection,
} from '../../redux/selector/memberDetails';

const Questions = ({
  errors,
  sectionData,
  index,
  showPageError,
  processing,
  theme,
  changeMode,
  isSmallScreen,
  memberDetailsIo,
  activeSubsectionId,
}) => {
  const {
    errorMessage,
    errorTitle,
    hasError,
  } = errors;

  const {
    pageId,
    pageLayout,
  } = theme

  const {
    config: {
      theme: {
        components: {
          card: { padding, marginLeft },
        },
        global: { errorMessageColor, errorFontSize },
      },
    },
  } = theme;

  const {
    id,
    review,
    questionList,
  } = sectionData;

  const isMemberDetailsPage = isMemberDetailsSubsection(activeSubsectionId);
  const combinedQuestionList = getCombinedSectionQuestions(sectionData);
  const isMemberDetailsIoSection = isMemberDetailsPage && (
    isVerifyMemberInfoSection(combinedQuestionList)
    || isSecondaryAddresseeSection(combinedQuestionList)
  );
  const isIoBlocking = isMemberDetailsPage && !!memberDetailsIo?.blocking;
  const isIoAlertSection = isMemberDetailsPage
    && isIoBlockingOwnerSection(sectionData, memberDetailsIo || {});
  const showSectionError = hasError
    && showPageError
    && !window.location.pathname.includes('timeout')
    && !(isIoBlocking && isIoAlertSection);

  return (
    <Card 
      key={ id }
      noStyle={ pageLayout ==='auto' }
      layout={ pageLayout }
      padding={ isSmallScreen && padding }
      marginLeft= { marginLeft }
    >
      { showSectionError && (
        <ScrollToTop>
          <Alert
            message={ errorMessage }
            type="error"
            title={ errorTitle }
            color={ errorMessageColor }
            fontSize={ errorFontSize }
          />
        </ScrollToTop>
      )}
      { isMemberDetailsIoSection && (
        <MemberDetailsAlerts
          questionList={ combinedQuestionList }
          errorMessageColor={ errorMessageColor }
          errorFontSize={ errorFontSize }
        />
      ) }
      <Section
        questionList={ questionList }
        key={ id }
        sectionIndex={ index }
        pageId={ pageId }
        reviewProps={ review }
        processing={ processing }
        changeMode= { changeMode }
      />
    </Card>
  )
}

const mapStateToProps = (state) => ({
  memberDetailsIo: get(state, 'questions.otherParams.member_details_io', null),
  activeSubsectionId: get(state, 'questions.activeSubsectionId', ''),
});

Questions.propTypes = {
  sectionData: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  showPageError: PropTypes.bool,
  memberDetailsIo: PropTypes.object,
  activeSubsectionId: PropTypes.string,
  processing: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
}

Questions.defaultProps = {
  showPageError: false,
}

export default connect(mapStateToProps)(withTheme(Questions));
